import { useTranslation } from 'react-i18next';

interface RoomTopLeftButtonsProps {
  onBack: () => void;
  onHelp: () => void;
}

/** Back button (hidden when the Telegram native back button is visible) + Help/Guide button. */
export default function RoomTopLeftButtons({ onBack, onHelp }: RoomTopLeftButtonsProps) {
  const { t } = useTranslation();

  return (
    <>
      {/* Back button - only show if Telegram back button is not visible */}
      {!window.Telegram?.WebApp?.BackButton?.isVisible && (
        <button
          onClick={onBack}
          style={{
            position: 'absolute',
            top: 16,
            left: 16,
            zIndex: 1000,
            background: 'rgba(0, 0, 0, 0.6)',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: 12,
            padding: '8px 16px',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          {t('Back')}
        </button>
      )}

      {/* Help/Guide button - always visible */}
      <button
        onClick={onHelp}
        style={{
          position: 'absolute',
          top: !window.Telegram?.WebApp?.BackButton?.isVisible ? 66 : 16,
          left: 16,
          zIndex: 1000,
          display: "flex",
          width: "36px",
          height: "36px",
          padding: 0,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
          border: "1px solid #AAA",
          background: "transparent",
          cursor: "pointer",
          flexShrink: 0,
        }}
        aria-label={t("Info")}
      >
        <img src="/ui/invite-friends/info-icon.svg" alt="" style={{ width: 14, height: 14, flexShrink: 0 }} />
      </button>
    </>
  );
}
